import { MEETING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID } from '../../constants';
import {
  VisitorSettingsDrawerControlMenuItemWrapper as BaseVisitorSettingsDrawerControlMenuItem,
  VisitorSettingsDrawerButton,
} from '../../controls/VisitorSettingsDrawerControlsWrapper';

export function VisitorMeetingSettingsControlButton() {
  return <VisitorSettingsDrawerButton drawerId={MEETING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID} />;
}

export function VisitorMeetingSettingsDrawerControlMenuItem() {
  return <BaseVisitorSettingsDrawerControlMenuItem drawerId={MEETING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID} />;
}
